(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lorolivo-ai-parrot"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('lorolivo-guide')) return;
    class LorolivoGuide extends HTMLElement {
      saveConversation() {
        try {
          sessionStorage.setItem(this.stateKey, JSON.stringify({
            history: this.history.slice(-20),
            open: !this.panel.hidden
          }));
        } catch {}
      }

      restoreConversation() {
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.stateKey) || 'null');
          if (!saved || !Array.isArray(saved.history)) return;
          this.history = saved.history
            .filter(item => item && ['user', 'assistant'].includes(item.role) && typeof item.content === 'string')
            .slice(-20);
          if (!this.history.length) return;

          const welcome = this.querySelector('[data-llg-welcome]');
          if (welcome) welcome.hidden = true;
          this.history.forEach(message => this.addTurn(message.content, message.role));

          if (saved.open) {
            this.panel.hidden = false;
            this.classList.add('is-open');
            this.launcher.setAttribute('aria-expanded', 'true');
          }
        } catch {
          try { sessionStorage.removeItem(this.stateKey); } catch {}
        }
      }

      rememberOliGreeting() {
        try { sessionStorage.setItem('lorolivo-oli-greeting-v2', '1'); } catch {}
      }

      async playOliIntro() {
        if (this._oliGreetingHandled || this.hidden || !this.panel.hidden || document.hidden || this._motion.matches) return;
        this._oliGreetingHandled = true;
        try {
          if (sessionStorage.getItem('lorolivo-oli-greeting-v2') === '1') return;
          sessionStorage.setItem('lorolivo-oli-greeting-v2', '1');
        } catch {
          return;
        }

        const bird = this.querySelector('.llg-launcher__bird');
        if (!bird || typeof bird.animate !== 'function') return;
        const generation = this._oliGeneration;
        try { await bird.decode(); } catch { return; }
        if (generation !== this._oliGeneration || !this.isConnected || this.hidden || !this.panel.hidden || document.hidden || this._motion.matches) return;

        const box = bird.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth;
        const side = Math.max(0, Math.min(10, viewportWidth - box.right - 7));
        this.classList.add('oli-greeting');
        const pose = (x, y, angle = 0, scale = 1) =>
          `translate3d(${x}px,${y}px,0) rotate(${angle}deg) scale(${scale})`;
        const ease = 'cubic-bezier(.4,0,.2,1)';
        this._oliBirdAnimation = bird.animate([
          { offset: 0, opacity: 1, transform: pose(0, 0), easing: ease },
          { offset: .18, opacity: 1, transform: pose(side, 0, -3), easing: ease },
          { offset: .29, opacity: 1, transform: pose(side, 0, -3), easing: ease },
          { offset: .40, opacity: 1, transform: pose(side, -1, 3), easing: ease },
          { offset: .48, opacity: 1, transform: pose(side, -1, 3), easing: ease },
          { offset: .54, opacity: 1, transform: pose(side, 2, 1, .985), easing: 'cubic-bezier(.2,.6,.35,1)' },
          { offset: .64, opacity: 1, transform: pose(side * .45, -13, -4), easing: 'cubic-bezier(.55,0,.8,.5)' },
          { offset: .74, opacity: 1, transform: pose(0, 0), easing: ease },
          { offset: .78, opacity: 1, transform: pose(0, 1, 0, .99), easing: ease },
          { offset: .83, opacity: 1, transform: pose(0, 0), easing: ease },
          { offset: .90, opacity: 1, transform: pose(0, 0, -5), easing: ease },
          { offset: .94, opacity: 1, transform: pose(0, 0, -5), easing: ease },
          { offset: 1, opacity: 1, transform: pose(0, 0) }
        ], { duration: 3600, fill: 'none' });
        this._oliBirdAnimation.finished.then(() => this.finishOliIntro()).catch(() => {});
      }

      finishOliIntro() {
        this._oliGeneration = (this._oliGeneration || 0) + 1;
        window.clearTimeout(this._oliStartTimer);
        this._oliBirdAnimation?.cancel();
        this._oliBirdAnimation = null;
        this.classList.remove('oli-greeting');
      }

      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this._oliGeneration = 0;
        this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._stopGreeting = () => this.finishOliIntro();
        this._motion.addEventListener('change', this._stopGreeting);
        document.addEventListener('visibilitychange', this._stopGreeting);
        window.addEventListener('resize', this._stopGreeting, { passive: true });
        this.stateKey = 'lorolivo-guide-conversation-v2';
        this.history = [];
        this.busy = false;
        this.panel = this.querySelector('[data-llg-panel]');
        this.launcher = this.querySelector('[data-llg-open]');
        this.input = this.querySelector('[data-llg-input]');
        this.messages = this.querySelector('[data-llg-messages]');
        this.scroller = this.querySelector('[data-llg-scroll]');
        this.send = this.querySelector('[data-llg-send]');
        this.texts = this.querySelector('[data-llg-texts]').dataset;
        this.restore = this.previousElementSibling;
        this.restoreConversation();
        this.querySelector('[data-llg-hide]').addEventListener('click', () => {
          this.setOpen(false);
          this.hidden = true;
          this.restore.hidden = false;
          try { sessionStorage.setItem('lorolivo-guide-hidden', '1'); } catch {}
          this.restore.focus({ preventScroll: true });
        });
        this.restore.addEventListener('click', () => {
          this.hidden = false;
          this.restore.hidden = true;
          try { sessionStorage.removeItem('lorolivo-guide-hidden'); } catch {}
          this.setOpen(true);
        });
        try { this.hidden = sessionStorage.getItem('lorolivo-guide-hidden') === '1'; } catch {}
        this.restore.hidden = !this.hidden;
        this.launcher.addEventListener('click', () => this.setOpen(this.panel.hidden));
        this.querySelector('[data-llg-close]').addEventListener('click', () => this.setOpen(false));
        this.querySelector('[data-llg-form]').addEventListener('submit', event => {
          event.preventDefault();
          this.ask(this.input.value);
        });
        this.querySelectorAll('[data-llg-prompt]').forEach(button => button.addEventListener('click', () => this.ask(button.dataset.llgPrompt)));
        this._escape = event => { if (event.key === 'Escape' && !this.panel.hidden) this.setOpen(false); };
        document.addEventListener('keydown', this._escape);
        this._place = () => this.place();
        window.addEventListener('resize', this._place, { passive: true });
        window.visualViewport?.addEventListener('resize', this._place, { passive: true });
        window.visualViewport?.addEventListener('scroll', this._place, { passive: true });
        this._previewObserver = new ResizeObserver(this._place);
        this._bodyObserver = new MutationObserver(() => this.observePreview());
        this._bodyObserver.observe(document.body, { childList: true });
        this.observePreview();
        this.place();
        this._oliStartTimer = window.setTimeout(() => this.playOliIntro(), 650);
      }

      disconnectedCallback() {
        if (!this._ready) return;
        if (this._oliStartTimer) clearTimeout(this._oliStartTimer);
        this.finishOliIntro();
        this._motion.removeEventListener('change', this._stopGreeting);
        document.removeEventListener('visibilitychange', this._stopGreeting);
        window.removeEventListener('resize', this._stopGreeting);
        this.controller?.abort();
        document.removeEventListener('keydown', this._escape);
        window.removeEventListener('resize', this._place);
        window.visualViewport?.removeEventListener('resize', this._place);
        window.visualViewport?.removeEventListener('scroll', this._place);
        this._previewObserver.disconnect();
        this._bodyObserver.disconnect();
      }

      observePreview() {
        const preview = document.getElementById('PBarNextFrameWrapper');
        if (preview !== this._preview) {
          this._previewObserver.disconnect();
          this._preview = preview;
          if (preview) this._previewObserver.observe(preview);
        }
        this.place();
      }

      place() {
        const viewport = window.visualViewport;
        const height = viewport?.height || window.innerHeight;
        const keyboard = viewport ? Math.max(0, window.innerHeight - height - viewport.offsetTop) : 0;
        const previewRect = this._preview?.getBoundingClientRect();
        const previewHeight = previewRect && previewRect.top < window.innerHeight && previewRect.height < window.innerHeight / 2 ? previewRect.height : 0;
        const obstruction = keyboard > 100 ? 0 : previewHeight;
        this.restore.style.bottom = `calc(${16 + obstruction}px + env(safe-area-inset-bottom,0px))`;
        this.style.setProperty('--ll-lift', `${Math.max(keyboard, obstruction)}px`);
        this.style.setProperty('--ll-obstruction', `${obstruction}px`);
        this.style.setProperty('--ll-vh', `${height}px`);
      }

      setOpen(open) {
        this.rememberOliGreeting();
        this._oliGreetingHandled = true;
        this.finishOliIntro();
        this.panel.hidden = !open;
        this.classList.toggle('is-open', open);
        this.launcher.setAttribute('aria-expanded', String(open));
        this.saveConversation();
        this.place();
        if (open) {
          if (matchMedia('(pointer:fine)').matches) this.input.focus({ preventScroll: true });
          else this.querySelector('[data-llg-close]').focus({ preventScroll: true });
        } else this.launcher.focus({ preventScroll: true });
      }

      async markOliAssisted(href, campaign = 'navegacion_chat') {
        const occurredAt = new Date().toISOString();
        let destinationPath = '';
        try {
          destinationPath = new URL(href, window.location.href).pathname.slice(0, 200);
        } catch {}

        const attributes = {
          __ll_oli_asistido: 'si',
          __ll_oli_canal: 'chat',
          __ll_oli_campana: campaign,
          __ll_oli_ultima_interaccion: occurredAt,
          __ll_oli_destino: destinationPath
        };

        try {
          localStorage.setItem('lorolivo-oli-attribution-v1', JSON.stringify({
            href,
            campaign,
            occurredAt
          }));
        } catch {}

        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            credentials: 'same-origin',
            keepalive: true,
            body: JSON.stringify({ attributes })
          });
          return response.ok;
        } catch {
          return false;
        }
      }

      async handleOliLinkClick(event, link) {
        const href = link.href;
        const campaign = link.dataset.oliCampaign || 'navegacion_chat';

        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          this.markOliAssisted(href, campaign);
          return;
        }

        event.preventDefault();
        await Promise.race([
          this.markOliAssisted(href, campaign),
          new Promise(resolve => setTimeout(resolve, 700))
        ]);
        window.location.assign(href);
      }

      renderTurnBody(body, text, role) {
        if (role !== 'assistant') {
          body.textContent = text;
          return;
        }

        body.replaceChildren();
        const value = String(text || '').replace(/\r\n/g, '\n').trim();
        const paragraphs = value.split(/\n{2,}/).filter(Boolean);
        const urlPattern = /https?:\/\/[^\s]+/g;

        const appendInline = (parent, source) => {
          const boldPattern = /\*\*([^*]+)\*\*/g;
          let boldLast = 0;
          for (const boldMatch of source.matchAll(boldPattern)) {
            const boldStart = boldMatch.index ?? 0;
            if (boldStart > boldLast) parent.append(document.createTextNode(source.slice(boldLast, boldStart)));
            const strong = document.createElement('strong');
            strong.textContent = boldMatch[1];
            parent.append(strong);
            boldLast = boldStart + boldMatch[0].length;
          }
          if (boldLast < source.length) parent.append(document.createTextNode(source.slice(boldLast)));
        };

        const appendLinkedText = (parent, source) => {
          let lastIndex = 0;
          for (const match of source.matchAll(urlPattern)) {
            const start = match.index ?? 0;
            if (start > lastIndex) appendInline(parent, source.slice(lastIndex, start));

            let url = match[0];
            let trailing = '';
            while (/[),.;!?]$/.test(url)) {
              trailing = url.slice(-1) + trailing;
              url = url.slice(0, -1);
            }

            const link = document.createElement('a');
            link.className = 'llg-answer-link';
            const destination = new URL(url, window.location.href);
            const isLorolivo = destination.hostname === 'lorolivo.com' || destination.hostname.endsWith('.lorolivo.com');
            const isProduct = destination.pathname.includes('/products/');
            const oliCampaign = isProduct ? 'recomendacion_producto' : 'navegacion_chat';

            if (isLorolivo) {
              destination.searchParams.set('utm_source', 'oli');
              destination.searchParams.set('utm_medium', 'chat');
              destination.searchParams.set('utm_campaign', oliCampaign);
              if (isProduct) {
                const productHandle = destination.pathname.split('/products/')[1]?.split('/')[0];
                if (productHandle) destination.searchParams.set('utm_content', productHandle);
              }
              link.dataset.oliCampaign = oliCampaign;
            }

            link.href = destination.href;
            if (!isLorolivo) {
              link.target = '_blank';
              link.rel = 'noopener noreferrer';
            }
            link.textContent = url.includes('lorolivo.com/products/')
              ? 'Ver producto →'
              : url.includes('lorolivo.com')
                ? 'Ver en Lorolivo →'
                : 'Abrir enlace →';
            if (isLorolivo) {
              link.addEventListener('click', event => this.handleOliLinkClick(event, link));
            }
            parent.append(link);
            if (trailing) appendInline(parent, trailing);
            lastIndex = start + match[0].length;
          }
          if (lastIndex < source.length) appendInline(parent, source.slice(lastIndex));
        };

        (paragraphs.length ? paragraphs : [value]).forEach(paragraph => {
          const lines = paragraph.split('\n');
          const bulletLines = lines.filter(line => /^\s*(?:[-*•])\s+/.test(line));
          if (bulletLines.length && bulletLines.length === lines.filter(line => line.trim()).length) {
            const list = document.createElement('ul');
            list.className = 'llg-answer-list';
            bulletLines.forEach(line => {
              const item = document.createElement('li');
              appendLinkedText(item, line.replace(/^\s*(?:[-*•])\s+/, ''));
              list.append(item);
            });
            body.append(list);
            return;
          }

          const p = document.createElement('p');
          lines.forEach((line, index) => {
            appendLinkedText(p, line);
            if (index < lines.length - 1) p.append(document.createElement('br'));
          });
          body.append(p);
        });
      }

      addTurn(text, role) {
        const turn = document.createElement('div');
        turn.className = `llg-turn llg-turn--${role}`;
        const label = document.createElement('span');
        label.className = 'llg-turn__label';
        label.textContent = role === 'user' ? this.texts.you : this.texts.assistant;
        const body = document.createElement('div');
        body.className = 'llg-turn__text';
        this.renderTurnBody(body, text, role);
        turn.append(label, body);
        this.messages.append(turn);
        this.scroller.scrollTop = this.scroller.scrollHeight;
        return { turn, body };
      }

      async ask(question) {
        const text = (question || '').trim().slice(0, 700);
        if (!text || this.busy) return;
        this.busy = true;
        this.send.disabled = true;
        this.input.readOnly = true;
        this.querySelectorAll('[data-llg-prompt]').forEach(button => { button.disabled = true; });
        this.querySelector('[data-llg-welcome]').hidden = true;
        this.addTurn(text, 'user');
        this.input.value = '';
        const pending = this.addTurn(this.texts.thinking, 'pending');
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 29000);
        try {
          let sessionId;
          try {
            sessionId = sessionStorage.getItem('oli_session_v1');
            if (!/^[a-zA-Z0-9_-]{16,80}$/.test(sessionId || '')) {
              sessionId = crypto.randomUUID();
              sessionStorage.setItem('oli_session_v1', sessionId);
            }
          } catch { sessionId = crypto.randomUUID(); }
          const response = await fetch('https://lorolivo-ai-api.vercel.app/api/chat', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ sessionId, messages: [...this.history.slice(-10), { role: 'user', content: text }] }),
            credentials: 'omit',
            signal: this.controller.signal
          });
          if (!response.ok) throw new Error('assistant_unavailable');
          const data = await response.json();
          if (typeof data.reply !== 'string' || !data.reply.trim()) throw new Error('empty_reply');
          pending.turn.className = 'llg-turn llg-turn--assistant';
          this.renderTurnBody(pending.body, data.reply, 'assistant');
          this.history.push({ role: 'user', content: text }, { role: 'assistant', content: data.reply });
          this.history = this.history.slice(-20);
          this.saveConversation();
        } catch {
          pending.turn.className = 'llg-turn llg-turn--error';
          pending.body.textContent = this.texts.error;
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'llg-retry';
          retry.textContent = this.texts.retry;
          retry.addEventListener('click', () => { if (!this.busy) { retry.remove(); this.ask(text); } });
          pending.turn.append(retry);
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          this.send.disabled = false;
          this.input.readOnly = false;
          this.querySelectorAll('[data-llg-prompt]').forEach(button => { button.disabled = false; });
          this.scroller.scrollTop = this.scroller.scrollHeight;
        }
      }
    }
    customElements.define('lorolivo-guide', LorolivoGuide);
  })();
  } catch(e) { console.error(e); }
})();

})();
